import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const DeleteStoryModal = ({ isOpen, onClose, onConfirm, storyTitle }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="bg-white rounded-2xl p-6 max-w-md w-full mx-4 shadow-dreamy"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-red-100 rounded-full">
              <SafeIcon icon={FiIcons.FiAlertTriangle} className="text-2xl text-red-600" />
            </div>
            <h3 className="text-xl font-display font-bold text-gray-900">
              Delete Story?
            </h3>
          </div>
          
          <p className="text-gray-600 mb-3">
            Are you sure you want to delete <span className="font-semibold">"{storyTitle}"</span>?
          </p>
          
          <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <SafeIcon icon={FiIcons.FiAlertCircle} className="text-red-500" />
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">
                  This will permanently delete:
                </p>
                <ul className="mt-2 text-sm text-red-700 list-disc list-inside">
                  <li>All story nodes</li>
                  <li>All options and choices</li>
                  <li>All connections between nodes</li>
                  <li>The story itself</li>
                </ul>
                <p className="mt-2 text-sm text-red-700 font-bold">
                  This action cannot be undone.
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex justify-end gap-3">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-medium"
              onClick={onClose}
            >
              Cancel
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-xl font-medium flex items-center gap-2"
              onClick={onConfirm}
            >
              <SafeIcon icon={FiIcons.FiTrash2} />
              Delete Story
            </motion.button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default DeleteStoryModal;